import styled from '@emotion/styled';
import TextField from '@base/TextField/TextField';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import { keyframes } from '@emotion/react';
import NumberField from '@base/NumberField/NumberField';
import Paper from '@base/Paper/Paper';
import Button from '@base/Button/Button';
import Dropdown from '@comp/Dropdown/Dropdown';
import DatePicker from '@base/DatePicker/DatePicker';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import CheckCircleFilled from '@icon/CheckCircleFilled';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import H4 from '@base/H4/H4';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import H6 from '@base/H6/H6';

export const Wrapper = styled.div`
  flex-grow: 1;
  max-width: 464px;
`;

export const TabletWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacings.SPACING_6B};
`;

export const StyledPaper = styled(Paper)`
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  }
`;

export const FormTitle = styled(H4)`
  margin-bottom: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

export const FormContainer = styled.form`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.aboveMobile} {
    margin-top: ${Spacings.SPACING_6B};
    & > div:nth-child(1) {
      margin: 0;
    }
  }
`;

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin-top: ${Spacings.SPACING_4B};
  font-size: ${Fonts.H6};
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: ${Spacings.SPACING_12B};
    border-radius: ${Spacings.SPACING_2B};
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
    }
  }
`;

export const FormSectionHeading = styled(H5)`
  margin-top: ${Spacings.SPACING_8B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

export const FieldWrapper = styled.div`
  .MuiInputBase-root {
    height: ${Spacings.SPACING_12B};
    &.Mui-disabled {
      ${mediaQuery.aboveMobile} {
        input {
          border-radius: ${Spacings.SPACING_2B};
        }
      }
    }
    .MuiInputBase-input,
    .MuiInputBase-input::placeholder {
      font-size: ${Fonts.SMALL};
      font-weight: ${Fonts.SEMIBOLD};
    }
  }
`;

export const ReferralFieldWrapper = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_14};
`;

export const ExtraFields = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_2B};
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    gap: ${Spacings.SPACING_4B};
  }
`;

export const FieldItemHeading = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.SMALL};
  margin-bottom: ${Spacings.SPACING_3B};
`;

export const FieldItem = styled.div`
  width: 50%;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

export const Error = styled(P2)`
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-i-red);
  margin-top: ${Spacings.SPACING_2B};
`;

export const StyledNumberField = styled(NumberField)`
  margin-top: ${Spacings.SPACING_4B};
  width: 100%;
  font-size: ${Fonts.H6};
  line-height: 50%;
  &.MuiOutlinedInput-root {
    width: 100%;
    height: ${Spacings.SPACING_12B};
    .MuiOutlinedInput-input {
      width: 100%;
      padding: ${Spacings.SPACING_4B} 14px;
    }
  }
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
  }
`;

export const StyledDropdown = styled(Dropdown)`
  margin-top: ${Spacings.SPACING_4B};
  border-color: var(--color-divider);
  padding: ${Spacings.SPACING_4B} 14px !important;
  box-shadow: none;
  height: ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
    font-size: ${Fonts.SMALL};
  }
  h6 {
    font-size: ${Fonts.SMALL};
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

export const GenderDropdown = styled(Dropdown)`
  border-color: var(--color-divider);
  padding: ${Spacings.SPACING_4B} 14px !important;
  height: ${Spacings.SPACING_12B};
  box-shadow: none;
  h6 {
    font-size: ${Fonts.SMALL};
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

export const StyDatePicker = styled(DatePicker)`
  svg {
    display: none;
  }
  &.MuiOutlinedInput-root {
    border-radius: ${Spacings.SPACING_2B};
    .MuiInputBase-input {
      font-size: ${Fonts.SMALL};
      color: var(--color-i-black);
    }
  }
`;

export const AcceptTerms = styled.div`
  margin-bottom: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_8B};
  font-size: ${Fonts.P2};
`;

export const TermsContent = styled.p`
  font-size: 10px;
  line-height: 15px;
  font-weight: ${Fonts.SEMIBOLD};
`;

export const TermsLink = styled.a`
  text-decoration: none;
  color: var(--color-i-black);
  cursor: pointer;
`;

export const StyP2 = styled(P2)`
  display: inline-block;
`;

export const TermsText = styled(StyP2)`
  font-weight: ${Fonts.SEMIBOLD};
`;

export const SubmitEnquiryButon = styled(Button)``;

export const CounsellorPaper = styled(Paper)`
  padding: ${Spacings.SPACING_0B};
`;

export const HR = styled.hr`
  background-color: var(--color-divider);
  height: 1px;
  border: none;
  ${mediaQuery.onlyTablet} {
    margin: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B};
  }
`;

export const CounsellorNameWrapper = styled.div`
  font-size: ${Fonts.SMALL};
  color: var(--color-i-gray-13);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_0B};
`;

export const CounsellorName = styled.span`
  color: var(--color-i-black);
  font-weight: 600;
`;

export const EnquiryThankyouSection = styled.div`
  display: flex;
  justify-content: center;
  width: 40%;
  margin: ${Spacings.SPACING_16B} auto;
  padding-top: ${Spacings.SPACING_10B};
  padding-bottom: ${Spacings.SPACING_15B};
  background: var(--color-i-white);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_8B};
    width: 100%;
  }
`;

export const ThankyouWrapper = styled.div``;

export const ImageContainer = styled.div`
  position: relative;
  text-align: center;
`;

const StyledImg = styled.img`
  user-drag: none;
  user-select: none;
`;

export const Confetti = styled(StyledImg)`
  width: 360px;
  height: 160px;
  object-fit: cover;
  object-position: center 35%;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 44.44vh;
    max-width: 360px;
    max-height: 160px;
  }
`;

const ShadowPulse = keyframes`
  0% { box-shadow: ${boxShadowGenerator({
    yOffset: '0',
    blur: '0',
    color: 'rgba(8, 189, 128, 0.4)'
  })}; }
  70% { box-shadow: ${boxShadowGenerator({
    yOffset: '0',
    blur: '0',
    spread: '10px',
    color: 'rgba(8, 189, 128, 0)'
  })}; }
  100% {
    box-shadow: none;
  }
`;

export const PulsatingGreenTick = styled(CheckCircleFilled)`
  animation: ${ShadowPulse} 2s infinite;
  border-radius: 50%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export const ThankyouHeader = styled(H3)`
  text-align: center;
  margin-top: -${Spacings.SPACING_8B};
  position: relative;
  color: var(--color-i-green);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

export const ThankyouSubHeader = styled(P1)`
  margin: auto;
  max-width: 55%;
  text-align: center;
  margin-top: ${Spacings.SPACING_2B};
`;

export const StaticInfoImageWrapper = styled.div`
  max-width: min-content;
  ${mediaQuery.uptoMobile} {
    max-width: 100%;
  }
`;

export const Heading = styled(H3)`
  max-width: 80%;
  ${mediaQuery.onlyTablet} {
    max-width: 85%;
    font-size: ${Fonts.H2};
    margin-bottom: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 422px;
  height: 237px;
  margin: ${Spacings.SPACING_6B} 0;
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 0 auto;
  }
  ${mediaQuery.onlyTablet} {
    margin: ${Spacings.SPACING_0B};
  }
  ${mediaQuery.uptoTablet} {
    width: 328px;
    height: 184px;
  }
`;

export const StaticInfoOfferingsWrapper = styled.div``;

export const SubHeading = styled(H6)`
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
  margin-bottom: ${Spacings.SPACING_5B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
  ${mediaQuery.onlyTablet} {
    margin-bottom: ${Spacings.SPACING_2B};
    font-size: ${Fonts.SMALL};
  }
`;

export const OfferingWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: ${Spacings.SPACING_6B};
  ${mediaQuery.onlyTablet} {
    margin-bottom: ${Spacings.SPACING_2B};
  }
  img {
    padding-top: ${Spacings.SPACING_2} !important;
  }
`;

export const OfferingText = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  padding-left: ${Spacings.SPACING_2B};
  max-width: 70%;
  ${mediaQuery.onlyTablet} {
    max-width: 90%;
  }
`;

export const EnquiryPageWrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_14B};
  width: 1024px;
  margin: auto;
  margin-top: ${Spacings.SPACING_20B};
  ${mediaQuery.uptoTablet} {
    flex-direction: column;
    margin-top: ${Spacings.SPACING_10B};
    width: 100%;
    gap: ${Spacings.SPACING_6B};
    padding: ${Spacings.SPACING_4B};
  }
  ${mediaQuery.onlyTablet} {
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_19B};
  }
`;

export const ExtraFieldsHR = styled(HR)`
  margin: ${Spacings.SPACING_8B} ${Spacings.SPACING_0B};
`;

export const ExtraFieldsHeading = styled(P1)`
  margin-bottom: -${Spacings.SPACING_1B};
`;
